import React from 'react';
import Chart from 'react-google-charts';
import Card from '../../Cards';
import Message from './Message'
import { countBy, getDate } from './DatesAnalytics';

export default function ChartContact({
  analyticsWeb,
  analyticsPhone,
  analyticsMail,
  analyticsWhatsapp,
  analyticsMedios,
}) {
  return (
    <div style={{ marginBottom: 24, height: 440 }}>
      <Card
        title="Contactado"
        subtitle1={getDate('month')}
        subtitle2={`${analyticsMedios.length} por otros medios`}
      >
        {analyticsMedios.length > 0 ? (
          <>
            <div style={{ height: '60%' }}>
              <Chart
                width={'100%'}
                height={'270px'}
                chartType="PieChart"
                loader={<div style={{marginBottom:16}}>Cargando gráfica...</div>}
                data={[
                  ['Medio', 'Veces contactado'],
                  ['WA', countBy('month', analyticsWhatsapp)],
                  ['TE', countBy('month', analyticsPhone)],
                  ['CE', countBy('month', analyticsMail)],
                  ['SW', countBy('month', analyticsWeb)],
                ]}
                options={{
                  legend: 'none',
                  colors: [
                    '#013957',
                    '#106c9d',
                    '#57a4cc',
                    '#478eb5',
                    '#146d9e',
                  ],
                  chartArea: {
                    width: '80%',
                    height: '75%',
                    backgroundColor: 'transparent',
                  },
                  pieSliceText: 'label',
                }}
                rootProps={{ 'data-testid': '1' }}
              />
            </div>
            <div className="legend-pie" style={{ height: '40%' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-evenly',
                }}
              >
                <div>
                  <div className="legend-pie-item">
                    <span className="legend-text">WA </span>
                    <span className="legend-value">WhatsApp</span>
                  </div>
                  <div className="legend-pie-item">
                    <span className="legend-text">CE </span>
                    <span className="legend-value">Correo Electrónico</span>
                  </div>
                </div>
                <div>
                  <div className="legend-pie-item">
                    <span className="legend-text">TE</span>
                    <span className="legend-value">Teléfono</span>
                  </div>
                  <div className="legend-pie-item">
                    <span className="legend-text">SW</span>
                    <span className="legend-value">Sitio Web</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
            <Message 
            title={'Aún no eres contactado'}
            description={'En cuanto recibas tu primer contacto te mostraremos las gráficas correspondientes.'}
            reminder={'Es importantes tener tu perfil actualizado, completo y participar en la comunidad.'}
          />
        )}
      </Card>
    </div>
  );
}
